import {Avatar,List, ListItem, ListItemAvatar, ListItemText} from "@mui/material";
import {makeStyles} from "@mui/styles";
import { useState} from "react";
import { PRIMARY_COLOR, SECONDARY_COLOR} from "../../../constants/Colors";
import Label from "../../../general_components/Label";
import {isToday, isYesterday, isThisWeek} from '../../../utilities/Others';
import AgentService from "../../../services/AgentService";
import useResponsive from "../../../hooks/useResponsive";

const useStyles = makeStyles({
    root: {
        width: '100%',
        // padding: 2,
    },
    editButton: {
        '&:hover': {
            cursor: 'pointer',
        },
    },
    highlighted: {
        backgroundColor: SECONDARY_COLOR,
    }
})


export default function AgentListItem({setShowDetails, data, setItem, filterValue, updateRequest })
{
    const classes = useStyles();

    const [highlight, setHighlight] = useState(-1);

    const isMobile = useResponsive('down', 'md');

    return (
        <div className={classes.root}>
            <List sx={{maxWidth: isMobile ? 'auto' : '25vw', minWidth: '25vw', maxHeight: isMobile ? '92vh' : '90vh',  overflowY: 'auto',paddingRight: 0.5, paddingLeft: 0.5}}>
                {
                    data.map((item, index) => {
                        return (
                            (filterValue.status === 'All' || filterValue.status === item.status)
                            &&
                            (
                                (filterValue.date === 'Today' && isToday(new Date(item.createdAt))) ||
                                (filterValue.date === 'Yesterday' && isYesterday(new Date(item.createdAt))) ||
                                (filterValue.date === 'This Week' && isThisWeek(new Date(item.createdAt))) ||
                                (filterValue.date === 'All Time' && true)
                            )
                        ) ? (
                            <ListItem
                                button
                                className={classes.editButton}
                                sx={{
                                    padding: 0,
                                    paddingTop: '1vh', paddingBottom: '1vh',
                                    paddingLeft: '1vh',
                                    borderRadius: 5,
                                    backgroundColor: highlight === item.requestId ? 'action.selected' : null,
                                }}
                                onClick={() => {
                                    AgentService.updateAgentRequests({requestId: item.requestId, isRead: true}).then(res => {
                                        if(res.data.success){
                                            updateRequest(item.requestId, {isRead: true})
                                            setHighlight(item.requestId)
                                            setShowDetails(true)
                                            setItem(item)
                                        }else {
                                            alert(res.data.error)
                                        }
                                    }).catch(e => {
                                        alert(e);
                                    })
                                }}
                            >
                                <ListItemAvatar>
                                    <Avatar style={{backgroundColor: highlight === item.requestId ? PRIMARY_COLOR : null}}>
                                        {index + 1}
                                    </Avatar>
                                </ListItemAvatar>
                                <ListItemText
                                    sx={{color: highlight === item.requestId ? PRIMARY_COLOR : null,
                                        textOverflow: 'ellipsis'}}
                                    primary={
                                        <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                                            {item.companyName}
                                            <div>
                                                {
                                                    item.isRead ? null :
                                                        <Label
                                                            variant="filled"
                                                            color={'primary'}
                                                            sx={{
                                                                textTransform: 'uppercase', marginRight: 0.5, color: '#fff'
                                                            }}
                                                        >
                                                            NEW
                                                        </Label>
                                                }
                                            </div>
                                        </div>
                                    }
                                    secondary={item.authPersonName}
                                />
                            </ListItem>
                        ) : null
                    })
                }
            </List>
        </div>
    );
}